import { fill } from './fill.js'
import templateUrl from './template.pdf'

export default {
  key: 'pgrc1to6_2023_07',
  templateUrl,
  fill,
}
